module.exports = __webpack_public_path__ + "img/hero.a8cc8d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero.png
// module id = mXZL
// module chunks = 0